import { Tooltip } from 'react-tooltip';
import styled from 'styled-components';

export const TooltipWrapper = styled(Tooltip)`
  max-width: 33%;
  @media (max-width: ${({ theme }) => theme.screen.sm}) {
    max-width: 90%;
    font-size: ${({ theme }) => theme.font.size.xxs};
  }
  z-index: ${({ theme }) => theme.zIndex.xxl};
`;
